import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=953b694a&scoped=true&"
import script from "./Exchange.vue?vue&type=script&lang=js&"
export * from "./Exchange.vue?vue&type=script&lang=js&"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=953b694a&prod&lang=scss&"
import style1 from "./Exchange.vue?vue&type=style&index=1&id=953b694a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953b694a",
  null
  
)

export default component.exports